import React from 'react';
import { Box, Modal, ModalBody, Text, Divider, Spinner, Heading } from '@razorpay/blade/components';
import {
  BusinessBankingIcon,
  ChevronRightIcon,
  CurrentAccountIcon,
} from '@razorpay/blade/components';

export const VerifyingBankAccountModal = ({
  isOpen,
  accountNumber,
  employeeName,
}: {
  isOpen: boolean;
  accountNumber?: string;
  employeeName?: string;
}) => {
  return (
    <Modal
      accessibilityLabel="verifying bank account"
      isOpen={isOpen}
      onDismiss={() => {
        //do nothing
      }}
      size="small">
      <ModalBody padding="spacing.0">
        <Box>
          <Heading margin="spacing.6" textAlign="center" color="surface.text.gray.normal">
            Verifying Bank Account
          </Heading>
          <Divider variant="muted" />
          <Box display="flex" justifyContent="space-between" alignItems="center" margin="spacing.7">
            <Box display="flex" flexDirection="column">
              <BusinessBankingIcon color="surface.icon.gray.normal" size="small" />
              <Text
                marginTop="spacing.4"
                size="small"
                weight="semibold"
                color="surface.text.gray.normal">
                Razorpay XPayroll
              </Text>
              <Text
                marginTop="spacing.2"
                size="xsmall"
                weight="regular"
                color="surface.text.gray.muted">
                {/* bav_TODO: update this with RazorpayX account number */}
                xxxxxxxxx
              </Text>
            </Box>
            <Box display="flex" alignItems="center">
              <ChevronRightIcon color="surface.icon.gray.disabled" />
              <ChevronRightIcon marginLeft="-8px" color="surface.icon.gray.disabled" />
              <ChevronRightIcon marginLeft="-8px" color="surface.icon.gray.disabled" />
              <ChevronRightIcon marginLeft="-8px" color="surface.icon.gray.disabled" />
              <ChevronRightIcon marginLeft="-8px" color="surface.icon.gray.disabled" />
            </Box>
            <Box display="flex" flexDirection="column">
              <CurrentAccountIcon color="surface.icon.gray.normal" size="small" />
              <Text
                marginTop="spacing.4"
                size="small"
                weight="semibold"
                color="surface.text.gray.normal">
                {employeeName}
              </Text>
              <Text
                marginTop="spacing.2"
                size="xsmall"
                weight="regular"
                color="surface.text.gray.muted">
                {accountNumber}
              </Text>
            </Box>
          </Box>
        </Box>
        <Box
          backgroundColor="surface.background.gray.subtle"
          display="flex"
          justifyContent="center"
          alignItems="center"
          padding="spacing.6"
          gap="spacing.3">
          <Spinner color="primary" accessibilityLabel="verifying account details" size="medium" />
          <Text size="small" weight="semibold" color="surface.text.gray.normal">
            Fetching Account Details
          </Text>
        </Box>
      </ModalBody>
    </Modal>
  );
};
